
<template>
    <div id="modalafter" class="modal">
        <div class="modal-content">
            <h4><strong>Merci de votre confiance !</strong></h4>
            <div id="email-pending">
                <p>Votre email est en cours de traitement ...</p>
                <div class="progress">
                    <div class="indeterminate"></div>
                </div>
            </div>
            <div id="email-sent-ok" hidden>
                <p class="green-text"><i class="material-icons left">check</i>Votre email a bien été reçu, je vous recontacte rapidement !</p>
            </div>
            <div id="email-sent-ko" hidden>
                <p class="red-text"><i class="material-icons left">close</i>Une erreur est survenue durant l'envoi de votre email :/<br>Merci de ressayer ultérieurement ou de me contacter directement.</p>
            </div>
        </div>
        <div class="modal-footer">
            <span class="modal-close waves-effect waves-green btn-flat">Fermer<i class="material-icons right">close</i></span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Modalafter'
}
</script>

<style scoped>
strong {
    font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/Modalafter.vue